import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';
import './index.scss';

const reqParams = '/engagement/churn';
const ChurnIndex = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile', shallowEqual);
  const pageMap: any = {
    mobile: MOBILE_PAGE_CONFIG,
    pc: PC_PAGE_CONFIG
  };

  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]}/>
    </>
  );
};

export default ChurnIndex;
